import { useAppContext } from '../../AppContext/AppContext';
import { CurrencyProperty } from '../../graphql/generated';
import { useTranslation } from '../../i18n/i18n';
import { OrderFlow } from '../../types';
import { PriceTag } from '../PriceTag/PriceTag';
import styles from './SummaryCard.module.css';

type SummaryCardProps = {
  value?: CurrencyProperty;
  withPriceOptimization?: boolean;
  variant?: 'priceOptimization' | 'sonnenBattery';
  dataTestId?: string;
  energyFix?: boolean;
};

const SummaryCard = ({ value, dataTestId = 'summary-card' }: SummaryCardProps) => {
  const { t } = useTranslation();

  if (!value) return null;

  const { orderFlow } = useAppContext();

  return (
    <div data-testid={dataTestId} className={styles.summaryCard}>
      {orderFlow === OrderFlow.selfConsumptionPlus && <p>{t('selfConsumptionPlus.title')}</p>}

      <div className={styles.valueCurrencyWrapper}>
        <PriceTag value={parseFloat(value.value)} size="Number3" />
      </div>
    </div>
  );
};

export default SummaryCard;
